
import { ConfigApi } from '@backstage/core-plugin-api';

export async function serviceProxy(
    config: ConfigApi,
    pathURL: string,
    method: string,
    contentData: any = {},
    queryParams: any = {}
) {
    // const config = useApi(configApiRef);
    const backendBaseUrl = config.getString('backend.baseUrl');
    try {
        const isGetOrHead = ['GET', 'HEAD'].includes(method.toUpperCase());
        let finalURL = `${backendBaseUrl}/api/routing-service/${pathURL}`;
        if (Object.keys(queryParams).length > 0) {
            const searchParams = new URLSearchParams(queryParams);
            finalURL += `?${searchParams.toString()}`;
        }
        const bodyData = isGetOrHead ? undefined : JSON.stringify(contentData);
        const response = await fetch(finalURL, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            ...(isGetOrHead ? {} : { body: bodyData }),
        });
        const result = await response.json();
        if (response.ok) {
            return result;
        }
        return { status: 210, fullyProcessed: false };
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}